import styled, { createGlobalStyle } from 'styled-components'

import { Img } from '@qonsoll/react-design'

const ImgStyled = styled(Img)`
  display: block;
  width: 240px;
  height: 240px;
  border-radius: 18px;
  object-fit: cover;
`

const HiddenScrollbarEmailModalStyles = createGlobalStyle`
  .auth-options-email-modal .ant-modal-body {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }

  .auth-options-email-modal .ant-modal-body::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none; /* Safari/Chrome */
  }
`

const circleAuthButton = {
  width: 56,
  height: 56,
  borderRadius: 28,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}

const styles = {
  carouselRowGap: { gap: 16 },
  carouselIcon: { fontSize: 18, color: 'var(--ql-color-accent1)' },
  rewardImageFrame: {
    width: 240,
    height: 240,
    borderRadius: 18,
    background: 'rgb(255, 255, 255)',
    overflow: 'hidden',
    boxShadow: '0 4px 18px rgba(0,0,0,0.06)',
    position: 'relative'
  },
  gridOverlayOuter: {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none'
  },
  gridLineVerticalLeft: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '33.3333%',
    width: 3,
    transform: 'translateX(-1.5px)',
    backgroundColor: 'rgb(255, 255, 255)'
  },
  gridLineVerticalRight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '66.6667%',
    width: 3,
    transform: 'translateX(-1.5px)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  },
  gridLineHorizontalUpper: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '33.3333%',
    height: 3,
    transform: 'translateY(-1.5px)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  },
  gridLineHorizontalLower: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '66.6667%',
    height: 3,
    transform: 'translateY(-1.5px)',
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  },
  headline: { fontSize: 22, fontWeight: 500 },
  authButtonsRowGap: { gap: 16 },
  buttonFacebook: {
    ...circleAuthButton,
    border: 'none',
    backgroundColor: '#1877F2',
    color: '#fff'
  },
  textFacebookIcon: { color: '#fff', fontWeight: 800, fontSize: 48 },
  socialIcon: {
    width: 56,
    height: 56,
    borderRadius: 28,
    objectFit: 'contain',
    display: 'block'
  },
  buttonEmail: {
    ...circleAuthButton,
    border: '2px solid var(--ql-color-accent1)',
    backgroundColor: '#fff',
    color: 'var(--ql-color-accent1)'
  },
  iconMail: { fontSize: 28 },
  buttonApple: {
    ...circleAuthButton,
    border: 'none',
    backgroundColor: '#000',
    color: '#fff'
  },
  iconApple: { fontSize: 28 },
  buttonVipps: {
    ...circleAuthButton,
    border: 'none',
    backgroundColor: 'rgb(255, 91, 36)',
    color: '#fff',
    padding: 0,
    overflow: 'hidden'
  },
  textVippsLabel: { color: '#fff', fontWeight: 800, fontSize: 18 },
  /**
   * Zoom + clip: image is larger than the button face; overflow hides the rest.
   */
  vippsIconClip: {
    position: 'relative',
    width: 56,
    height: 56,
    borderRadius: 28,
    overflow: 'hidden',
    display: 'block',
    flexShrink: 0
  },
  vippsIconImg: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 60,
    height: 60,
    transform: 'translate(-50%, -50%)',
    objectFit: 'cover',
    objectPosition: 'center',
    display: 'block',
    pointerEvents: 'none'
  },
  dividerTop: { margin: '0 0 24px 0' },
  emailModalBody: {
    borderRadius: '20px',
    height: '84vh',
    width: '100%',
    margin: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 20
  },
  buttonTipWizard: {
    height: 52,
    borderRadius: 12,
    backgroundColor: '#666',
    borderColor: '#666',
    color: '#fff',
    fontSize: 18,
    fontWeight: 500
  }
}

export { HiddenScrollbarEmailModalStyles, ImgStyled, styles }
